import React, { useContext, useState } from 'react';

import { Box, Button, FormControl, TextField } from '@mui/material';
import { Link, Navigate } from 'react-router-dom';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import DadosUsuario from '../../utils/context';
import { fetchFlask } from '../../utils/fetchFlask';

const AUTHORIZED_ROLES = ['PedidosOeMGerencial', 'Adm'];

const NovoMaterial = () => {
    const { autorizacoes = [] } = useContext(DadosUsuario);
    const canAccess = AUTHORIZED_ROLES.some((role) => autorizacoes.includes(role));

    const [material, setMaterial] = useState('');
    const [unit, setUnit] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    if (!canAccess) {
        return <Navigate to='/403-Unauthorized' replace />;
    }

    async function submitNovoMaterial (e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({
            material,
            unit
        });

        const response = await fetchFlask('newMaterial', body);
        setMessage(response.message);
        setStatus(response.status);
        setOpenAlerta(true);

        if (response.status === 'success') {
            setMaterial('');
            setUnit('');
        }

        setIsSubmit(false);
    }

    return (
        <Box className='mainBox'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />

            <PageHeader>
                Novo Material
            </PageHeader>

            <Link to='/'>
                <Button>
                    Voltar
                </Button>
            </Link>

            <form action='' method='POST' id='formNewMaterial' onSubmit={submitNovoMaterial}>
                <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                    <TextField
                        label='Material'
                        variant='outlined'
                        fullWidth
                        value={material}
                        onChange={(e) => setMaterial(e.target.value)}
                        required
                    />
                </FormControl>

                <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                    <TextField
                        label='Unidade'
                        variant='outlined'
                        fullWidth
                        value={unit}
                        onChange={(e) => setUnit(e.target.value)}
                        required
                    />
                </FormControl>

                <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                    <SubmitButton isSubmit={isSubmit}>
                        Adicionar Material
                    </SubmitButton>
                </FormControl>
            </form>
        </Box>
    );
};

export default NovoMaterial;
